import { handleActions } from "redux-actions";

const _defaultState = undefined;

function createReducer(actionName, defaultData = undefined) {
  const defaultState = Object.assign({}, _defaultState, { data: defaultData });

  return handleActions(
    {
      [`FETCH_SUCCESS_${actionName}`]: (state, action) => {
        return { ...state, ...action };
      },
      [`FETCH_FAILURE_${actionName}`]: (state, action) => {
        console.log("fetch_error: ", state);
        state = { ...state, ...action };
        return action.setToDefaultIfError ? { ...state, ...defaultState } : { ...state };
      },
    },
    { ...defaultState },
  );
}

export default createReducer;
